import lottie from "lottie-web"

export default () => ({
    initLottie(elementSelector, animationData) {
        const checkAndLoadLottie = () => {
            if (!this.store) {
            requestAnimationFrame(checkAndLoadLottie)
            return
            }

            const elements = document.querySelectorAll(elementSelector)
            if (elements.length > 0) {
            elements.forEach((element) => {
                if (!element.dataset.lottieLoaded) {
                lottie.loadAnimation({
                    container: element,
                    animationData: animationData,
                    renderer: "svg",
                    loop: true,
                    autoplay: true,
                })
                element.dataset.lottieLoaded = "true"
                }
            })
            } else {
            requestAnimationFrame(checkAndLoadLottie)
            }
        }

        requestAnimationFrame(checkAndLoadLottie)
    },
  })